<div class="flex-container" *ngIf="forkedData$ | async as fork; else loading">

  <!--*******************
  *       CARDS
  ***********************-->

  <div class="flex-container__cards">

    <!-- DEATH CARD -->
    <data-card
      mainTitle="Total Deaths"
      secondaryTitle="Per Million"
      [cumulativeData]="fork.cumulativeData.deaths"
      [todayCumulativeData]="fork.cumulativeData.todayDeaths"
      [perMillionCumulativeData]="fork.cumulativeData.deathsPerOneMillion"
      [isRotatable]="true"
      cardTextColor="darkred"
    >
    </data-card>
    <!--/ DEATH CARD -->

    <!-- CASES CARD -->
    <data-card
      mainTitle="Total Confirmed Cases"
      secondaryTitle="Per Million"
      [cumulativeData]="fork.cumulativeData.cases"
      [todayCumulativeData]="fork.cumulativeData.todayCases"
      [perMillionCumulativeData]="fork.cumulativeData.casesPerOneMillion"
      [isRotatable]="true"
      cardTextColor="lightcoral"
    >
    </data-card>
    <!--/ CASES CARD -->

    <!-- RECOVERED CARD -->
    <data-card
      mainTitle="Total Recovered"
      secondaryTitle="Per Million"
      [cumulativeData]="fork.cumulativeData.recovered"
      [todayCumulativeData]="fork.cumulativeData.todayRecovered"
      [perMillionCumulativeData]="fork.cumulativeData.recoveredPerOneMillion"
      [isRotatable]="true"
      cardTextColor="seagreen"
    >
    </data-card>
    <!--/ RECOVERED CARD -->

    <!-- CRITICAL CARD -->
    <data-card
      mainTitle="Total Critical"
      secondaryTitle="Per Million"
      [cumulativeData]="fork.cumulativeData.critical"
      [perMillionCumulativeData]="fork.cumulativeData.criticalPerOneMillion"
      [isRotatable]="true"
      cardTextColor="royalblue"
    >
    </data-card>
    <!--/ CRITICAL CARD -->

    <!-- TESTS CARD-->
    <data-card
      mainTitle="Total Tests"
      secondaryTitle="Per Million"
      [cumulativeData]="fork.cumulativeData.tests"
      [todayCumulativeData]="fork.cumulativeData.testsPerOneMillion"
      [isRotatable]="false"
      cardTextColor="darkcyan"
    >
    </data-card>
    <!--/ TESTS CARD -->

    <!-- ACTIVE CARD -->
    <data-card
      mainTitle="Total Active Cases"
      secondaryTitle="Per Million"
      [cumulativeData]="fork.cumulativeData.active"
      [perMillionCumulativeData]="fork.cumulativeData.activePerOneMillion"
      [isRotatable]="true"
      cardTextColor="#e0774b"
    >
    </data-card>
    <!--/ ACTIVE CARD -->

    <!-- MORTALITY RATE CARD -->
    <data-card
      mainTitle="Case Mortality Rate"
      [cumulativeData]="fork.cumulativeData.deaths / fork.cumulativeData.cases"
      [isRotatable]="false"
      isPercentage="true"
      cardTextColor="lightslategray"
    >
    </data-card>
    <!--/ MORTALITY RATE CARD -->

    <!-- POPULATION CARD -->
    <data-card
      mainTitle="World Population"
      [cumulativeData]="fork.cumulativeData.population"
      [isRotatable]="false"
      cardTextColor=" #33983e"
    >
    </data-card>
    <!--/POPULATION CARD-->

  </div>

  <!--*******************
  *       CHARTS
  ***********************-->
  <!-- DELTA TOGGLE -->
  <mat-slide-toggle class="flex-container__charts--toggle"
                    (change)="isDelta = $event.checked"
  >Switch to {{!isDelta ? 'Delta' : 'Total'}} Data
  </mat-slide-toggle>
  <!-- /DELTA TOGGLE -->

  <div class="flex-container__charts">


    <!-- VACCINES CHART -->
    <scale-area
      *ngIf="!isDelta"
      chartTitle="Vaccines Progress"
      seriesName="Vaccines Progress"
      [country]="countryName"
      [data]="fork.vaccinesTimeSeries"
      [date]="fork.vaccinesDates">
    </scale-area>
    <!-- /VACCINES CHART -->

    <!-- VACCINES DELTA CHART -->
    <scale-area
      *ngIf="isDelta"
      chartTitle="Vaccines Delta Progress"
      seriesName="Vaccines Delta Progress"
      [country]="countryName"
      [data]="fork.vaccinesTimeSeriesDelta"
      [date]="fork.vaccinesDates">
    </scale-area>
    <!-- /VACCINES DELTA CHART -->


    <!-- CASES PROGRESS -->
    <scale-area
      *ngIf="!isDelta"
      chartTitle="Cases Progress"
      seriesName="Cases"
      [country]="countryName"
      [data]="fork.timeSeriesCases"
      [date]="fork.timeSeriesDates">
    </scale-area>
    <!-- /CASES PROGRESS -->

    <!-- CASES DELTA  -->
    <scale-area
      *ngIf="isDelta"
      class="m-5"
      chartTitle="Delta Cases"
      seriesName="Delta Cases"
      [country]="countryName"
      [data]="fork.timeSeriesDeltaCases"
      [date]="fork.timeSeriesDates">
    </scale-area>
    <!-- /CASES DELTA  -->

    <!-- DEATHS PROGRESS -->
    <scale-area
      *ngIf="!isDelta"
      class="m-5"
      chartTitle="Deaths Progress"
      seriesName="Deaths"
      [country]="countryName"
      [data]="fork.timeSeriesDeaths"
      [date]="fork.timeSeriesDates">
    </scale-area>
    <!-- /DEATHS PROGRESS -->

    <!-- DEATHS DELTA  -->
    <scale-area
      *ngIf="isDelta"
      class="m-5"
      chartTitle="Delta Deaths"
      seriesName="Delta Deaths"
      [country]="countryName"
      [data]="fork.timeSeriesDeltaDeaths"
      [date]="fork.timeSeriesDates">
    </scale-area>
    <!-- /DEATHS DELTA  -->

    <!-- MORTALITY RATE  -->
    <scale-area
      *ngIf="!isDelta"
      class="m-5"
      chartTitle="Mortality Rate Progress"
      seriesName="Mortality Rate"
      [country]="countryName"
      [data]="fork.historicalMortalityRate"
      [date]="fork.timeSeriesDates">
    </scale-area>
    <!-- /MORTALITY RATE  -->

  </div>

</div>
<ng-template #loading>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
